import React from "react";
import WeddingPagination from "../wedding-pagination/WeddingPagination";
import styles from "./Listings.module.css";
import EventCard from "components/page-content/search-content/EventCard";
import { Link } from "react-router-dom";
import LoadingSpinner from "components/UI/loading-spinner/LoadingSpinner";

const Listings = ({
  listings,
  totalItems,
  currentPage,
  setCurrentPage,
  paginationChange,
  setPaginationChange,
  limit,
  loading,
  initialLoad,
}) => {
  function createSlug(title) {
    return title
      .toLowerCase() // Convert to lowercase
      .trim() // Remove leading/trailing spaces
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, "") // Remove special characters
      .replace(/--+/g, "-"); // Replace multiple hyphens with a single one
  }

  return (
    <div className={styles.listings}>
      <div className={styles.cards}>
        {listings.length > 0 &&
          listings.map((card) => (
            <Link
              key={card._id}
              to={`/${createSlug(card.categoryName)}/${card.slug}`}
            >
              <EventCard
                listingId={card._id}
                image={card?.images[0]}
                title={card?.name}
                review={card.review}
                city={card?.location?.locationName}
                state={card.state}
                price={card?.availableDates?.[0]?.intervals?.[0]?.price ?? ""}
                strikePrice={card.strikePrice}
                showPrice={card?.showPrice == "Yes" ? true : false}
                categoryName={card?.categoryName}
                listingType={card?.listingType}
              />
            </Link>
          ))}
      </div>

      {/* Loading Spinner - Show when loading and no data yet */}
      {loading && listings.length === 0 && (
        <div>
          <LoadingSpinner />
        </div>
      )}

      {/* No Data Found - Show only after initial load is complete, not loading, and no listings */}
      {!initialLoad && !loading && listings.length === 0 && (
        <h4 className={`${styles.errorText} home-error`}>No Data Found</h4>
      )}
      {totalItems > limit && listings.length > 0 && (
        <WeddingPagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItemsCount={totalItems}
          itemsCountPerPage={limit}
          paginationChange={paginationChange}
          setPaginationChange={setPaginationChange}
          localVariable="searchPagination"
        />
      )}
    </div>
  );
};

export default Listings;
